/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * For Smart Query searches only. Possible values are: `content` and `transmission`
 * @export
 * @enum {string}
 */

export enum SmartQuerySearchIndex {
    CONTENT = 'content',
    TRANSMISSION = 'transmission',
    CHANNEL = 'channel'
}



